module.exports = __webpack_public_path__ + "img/vc.1fbd575f.svg";